package music.jammers.shared.event.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class EventData(
    val title: String,
    val description: String,
    val date: LocalDateTime,
    val genre: String,
    val spot: String,
    val songsCount: Int,
    val appliesPerPerson: Int,
    val cardInfo: CardInfo,
    val selectedInstrumentList: List<EventInstrument>,
)